import { ClientDetailsApi, ClientGrantApi } from "go-component/components/ClientDetails/services/types";
import { parseApiData } from "go-core/api/parseApiData";
import { restSecurityApi } from "go-security/services/Api/api";

class adminApi {
	static getClientDetails = (
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<ClientDetailsApi[]> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	};

	static addClientDetail = (data: ClientDetailsApi): Promise<ClientDetailsApi> => {
		return parseApiData(restSecurityApi.post(`/security/client_details`, data));
	};

	static editClientDetail = (clientDetailId: string, data: ClientDetailsApi): Promise<ClientDetailsApi> => {
		return parseApiData(restSecurityApi.put(`/security/client_details/${clientDetailId}`, data));
	};

	static deleteClientDetail = (clientDetailId: string): Promise<{}> => {
		return parseApiData(restSecurityApi.delete(`/security/client_details/${clientDetailId}`));
	};

	static getClientScopes = (params?: Record<string, any>, options?: Record<string, any>): Promise<string[]> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details/scopes`, { params, cancelToken: options?.cancelToken })
		);
	};

	static getClientGrantTypes = (params?: Record<string, any>, options?: Record<string, any>): Promise<string[]> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details/authorized_grant_types`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	};

	static getClientSecret = (
		clientId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<string> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details/${clientId}/client_secret`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	};

	// GRANTS

	static getAllClientGrants = (
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<ClientGrantApi[]> => {
		return parseApiData(
			restSecurityApi.get("/security/client_details/client_grants", {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	};

	static getClientGrants = (
		clientId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<ClientGrantApi[]> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details/${clientId}/client_grants`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	};

	static getClientGrant = (
		clientId: string,
		grantId: number,
		params?: Record<string, any>
	): Promise<ClientGrantApi> => {
		return parseApiData(
			restSecurityApi.get(`/security/client_details/${clientId}/client_grants/${grantId}`, {
				params,
			})
		);
	};

	static updateClientGrant = (
		clientId: string,
		data: ClientGrantApi,
		params?: Record<string, any>
	): Promise<ClientGrantApi> => {
		return parseApiData(
			restSecurityApi.put(`/security/client_details/${clientId}/client_grants/${data.id}`, data, {
				params,
			})
		);
	};

	static createClientGrant = (
		clientId: string,
		data: ClientGrantApi,
		params?: Record<string, any>
	): Promise<ClientGrantApi> => {
		return parseApiData(
			restSecurityApi.post(`/security/client_details/${clientId}/client_grants`, data, {
				params,
			})
		);
	};

	static revokeClientGrant = (
		clientId: string,
		grantId: number,
		params?: Record<string, any>
	): Promise<ClientGrantApi> => {
		return parseApiData(
			restSecurityApi.put(`/security/client_details/${clientId}/client_grants/${grantId}/revoke`, undefined, {
				params,
			})
		);
	};

	static activateClientGrant = (
		clientId: string,
		grantId: number,
		params?: Record<string, any>
	): Promise<ClientGrantApi> => {
		return parseApiData(
			restSecurityApi.put(`/security/client_details/${clientId}/client_grants/${grantId}/activate`, undefined, {
				params,
			})
		);
	};

	static removeClientGrant = (clientId: string, grantId: number): Promise<{}> => {
		return parseApiData(restSecurityApi.delete(`/security/client_details/${clientId}/client_grants/${grantId}`));
	};
}

export { adminApi };
